import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import layer1 from "../../public/images/layer1.png";
import faqssvg1 from "../../public/svg/faqssvg1.svg";
import faqssvg2 from "../../public/svg/faqssvg2.svg";
import faqsimg from "../../public/images/faqsimg.png";
import { motion } from 'framer-motion';
import { truncateFiftyWord } from '@/utils/constant';
import FaqsForm from './faqsform';
import faqgetstarted from "../../public/images/faqgetstarted2.png"

const Faquestions = () => {

  const [activeAccordion, setActiveAccordion] = useState(accordionData2[0]);
  const [animate, setAnimate] = useState(false);
  const [faqForm, setFaqForm] = useState(false);

  useEffect(() => {
    if (activeAccordion) {
      setAnimate(true);
      const timer = setTimeout(() => setAnimate(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [activeAccordion]);

  const toggleAccordion2 = (item) => {
    setActiveAccordion(item);

  };

  const isFirst = 0;
  const isLast = accordionData2.length - 1;

  const handleFaqForm = () => {
    setFaqForm(true);
  }

  return (
    <>
      {faqForm && (
        <FaqsForm
          isOpen={faqForm}
          onClose={() => setFaqForm(false)} />
      )}
      <div className='relative'>
        <div className='my-10 2xl:mx-24 xl:mx-24 lg:mx-24 md:mx-20 sm:mx-10 mx-5'>
            <h2 className="font-extrabold text-center justify-center lg:text-6xl" >Frequently Asked Questions</h2>
            <p className='text-base text-center mt-2'>Some questions about campus drive asked frequently. We've answered the most frequent of those frequent questions below.</p>
          <div className='grid grid-cols-12 lg:gap-16 relative z-[11]'>
           <div className='col-span-12 lg:col-span-5 flex flex-col justify-center items-center'>
           <div className='h-48 w-56 mb-10 '>
              <Image src={faqgetstarted} alt='mock interviews' />
            </div>
            <motion.div
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              className="scroll-content bg-white border-[#1e336a] shadow-lg rounded-[10px] border-y-[5px] border-x-[1px] w-full ">
              {accordionData2.length > 0 &&
                accordionData2.map((item2, index2) => (
                  <div className="accordion-item2 " key={index2}>
                    <div
                      onClick={() => toggleAccordion2(item2)}
                      className={`accordion-item-label2 text-xl font-extrabold ${isFirst === index2 ? "" : ""} ${isLast === index2 ? '' : ''} flex justify-between items-center py-3 px-4 
                    ${activeAccordion?.title2 === item2?.title2 ? "bg-[#51a9ff]" : index2 % 2 === 0 ? "bg-[#cfe2ff]" : "bg-[#b5cff6]"} cursor-pointer`}>
                      <div className='flex items-center'>
                        <div className='ml-5 my-1'><h5>{item2?.title2}</h5></div>
                      </div>
                    </div>
                  </div>
                ))}
            </motion.div>
            </div>
            <div className={`col-span-12 lg:col-span-7 box ${animate ? "animate-transform" : ""}`}>
              <i className="fa fa-quote-right fa2 flex justify-center" >
                <Image src={faqssvg2} alt='how to prepare resume for freshers' className='h-auto w-16' />
              </i>
              <i className="fa fa-quote-left fa1 flex justify-center ">
                <Image src={faqssvg1} alt='resume builder for freshers' className='h-auto w-16' />
              </i>
              <div className="text">
                <div>
                  <h3>{activeAccordion?.title2}</h3>
                  <p>{truncateFiftyWord(activeAccordion?.content2)}</p>
                </div>
              </div>
            </div>
          </div>
          <div className='flex flex-col items-end mt-10 lg:-mt-40 relative z-10'>
            <p className='text-right text-xl'>Can't find what you are looking for?</p>
            <div className='text-right text-3xl'>We would like to help you,</div>
            <button className='text-right mr-20'
              onClick={() => handleFaqForm()}>
              <Image src={faqsimg} alt='online resume preparation' className='h-auto w-32' />
            </button>
          </div>
        </div>
        <div className='absolute top-[150px] right-0 left-0 bottom-0 z-[-10] w-full h-full'>
          <Image src={layer1} alt='career advice' className=' relative -z-0 w-full h-full' />
        </div>
      </div>
    </>
  )
}

const accordionData2 = [
  {
    title2: 'What is virtual campus drive?',
    content2: 'Virtual campus recruitment is the process of hiring talent from universities and colleges using remote hiring methods. This modern approach includes various digital means such as online screening, video conferencing, online job fairs, and other remote tools to interview and hire potential candidates. By leveraging these technologies, organizations can efficiently connect with a wider pool of candidates without geographical constraints.',
  },
  {
    title2: 'Why virtual campus drive? ',
    content2: 'A virtual campus drive provides an unparalleled opportunity to access a vast talent pool, transcending physical boundaries. This approach allows companies to extend their search beyond local institutions, tapping into the most suitable candidates from multiple universities and colleges globally. By embracing virtual campus recruitment, organizations can efficiently connect with a diverse range of talent, enhancing their ability to find the perfect fit for their needs.',
  },
  {
    title2: 'What are the advantages of Campus Hiring?',
    content2: 'According to industry reports, many campus recruitment professionals consider virtual campus recruitment to be a cost-effective and time-saving alternative to traditional on-campus recruitment. Physical on-campus recruitment often demands extensive planning, resources, and expenses. In contrast, online campus recruitment streamlines the process by eliminating these logistical challenges. With virtual hiring, organizations can reduce costs, save time, and reach a broader pool of candidates more efficiently, making the recruitment process more streamlined and effective.',
  },
  {
    title2: 'Major challenges in recruitment during Campus Hiring?',
    content2: 'Recruiting on-campus presents several significant challenges, primarily due to the extensive planning and resources required. Companies often need to invest heavily in travel, accommodation, and other ancillary expenses when visiting campuses. These costs can add up quickly, making the process less efficient and more cumbersome. Additionally, coordinating schedules and logistics for on-campus interviews can be complex, potentially delaying the hiring process and increasing overall expenses.',
  },
  {
    title2: 'Difference in between On-campus and Off-Campus drive?',
    content2: 'On-Campus Recruitment involves companies hiring a large number of fresh talents directly from universities and colleges. This process typically takes place at the institutions premises, using either online or offline methods.  Off-Campus Recruitment, on the other hand, eliminates the need for colleges or universities to be involved in the hiring process. Instead, companies invite candidates from various institutions to their own locations or virtual platforms for interviews and assessments. This approach allows organizations to reach a wider pool of talent, including those who may not be enrolled in the hosting institutions.',
  },
  {
    title2: 'What is the average offered salary during campus drive?',
    content2: 'The average salary offered during campus recruitment varies widely depending on several factors, including the type of colleges or universities, their grade and ranking, the courses and streams offered, and the companies involved. As such, it is challenging to predict a specific average salary for on-campus, off-campus, or virtual campus drives. Each recruitment event is unique, and salaries can differ significantly based on these various determinants.',
  },
  {
    title2: 'Campus placement situation in India?',
    content2: 'According to available sources, only 7% of Indian colleges achieve full campus placement. A significant challenge for many recruiters is the skill gap and the difficulty in identifying the right talent. Reports indicate that 66% of recruiters and 42% of universities acknowledge the existence of this skill gap, which hampers the placement process. This disparity highlights the need for enhanced training and better alignment between educational curricula and industry requirements to improve campus placement outcomes in India.',
  },
  {
    title2: 'How easycampus can resolve your campus drive challenges?',
    content2: 'Our unified process enables universities/colleges to automate end-to-end campus placements, helps employers to hire young talent from universities/colleges and empowers students for their skill development & to access opportunities democratically. Our platform, enabled by upgraded technologies and assisted by our experts, helps companies to source, screen, assess, interview, select, and onboard the best talent across the country.',
  },
];

export default Faquestions;
